import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
import permission from './modules/permission'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // mag/年鉴/期刊模块：详情页用于“反显/高亮”的字段集合（跨新开窗口传递）
    searchParamStrList: []
  },
  mutations: {
    setParamStrList (state, list) {
      state.searchParamStrList = Array.isArray(list) ? list : []
    }
  },
  modules: {
    app,
    user,
    permission,
  }
})
